import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import {
  MetricsCards,
  BurnupTicketsChart,
  ConcurrentTicketsChart,
  AgentFilterSelect
} from './componentes';
import { useDashboardMetrics } from '../hooks/useDashboardMetrics';
import useToken from 'hooks/useToken';

const DashboardView = () => {
  const { token, nombreCompleto, idUsuario } = useToken();
  // Filtros independientes de asesor para cada sección
  const [metricsAgentId, setMetricsAgentId] = useState('');
  const [burnupAgentId, setBurnupAgentId] = useState('');
  const [concurrentAgentId, setConcurrentAgentId] = useState('');

  const [agents, setAgents] = useState([]);
  const [isLoadingAgents, setIsLoadingAgents] = useState(false);
  const isFetchingAgentsRef = useRef(false);

  // Cargar lista de agentes activos para los selectores
  const fetchAgents = useCallback(async () => {
    if (!token || isFetchingAgentsRef.current) return;
    isFetchingAgentsRef.current = true;
    setIsLoadingAgents(true);
    try {
      const response = await fetch('/api/SupportEngine/GetAgentsList', {
        headers: { Accept: 'application/json', Authorization: 'Bearer ' + token }
      });
      if (response.ok) {
        const result = await response.json();
        const data = result.data || (Array.isArray(result) ? result : []);
        setAgents(Array.isArray(data) ? data : []);
      }
    } catch {
      // Silencioso
    } finally {
      isFetchingAgentsRef.current = false;
      setIsLoadingAgents(false);
    }
  }, [token]);

  useEffect(() => {
    fetchAgents();
  }, [fetchAgents]);

  const { metrics, isLoading } = useDashboardMetrics(metricsAgentId);

  return (
    <div>
      {/* Title Header with Agent Filter */}
      <div className="d-flex justify-content-between align-items-start align-items-md-center mb-4 flex-column flex-md-row gap-3">
        <div className="se-dashboard-header-card">
          <h3 className="fw-bold text-900 mb-1" style={{ fontSize: '1.6rem' }}>
            Visión General
          </h3>
          <p className="text-500 mb-0" style={{ fontSize: '0.90rem', color: '#64748b' }}>
            Métricas en tiempo real de la operación de soporte por WhatsApp.
          </p>
        </div>

        <div className="se-agent-filter-card-wrapper">
          <AgentFilterSelect
            variant="card"
            selectedAgentId={metricsAgentId}
            onSelectAgent={setMetricsAgentId}
            agents={agents}
            currentUserId={idUsuario}
            currentUserName={nombreCompleto}
            isLoadingAgents={isLoadingAgents}
          />
        </div>
      </div>

      {/* 4 KPI Cards + 2 SLA Cards */}
      <MetricsCards data={metrics} isLoading={isLoading} agentId={metricsAgentId} />

      {/* Charts */}
      <Row className="g-3">
        <Col xs={12}>
          <BurnupTicketsChart
            selectedAgentId={burnupAgentId}
            onSelectAgent={setBurnupAgentId}
            agents={agents}
            currentUserId={idUsuario}
            currentUserName={nombreCompleto}
            isLoadingAgents={isLoadingAgents}
          />
        </Col>
        <Col xs={12}>
          <ConcurrentTicketsChart
            selectedAgentId={concurrentAgentId}
            onSelectAgent={setConcurrentAgentId}
            agents={agents}
            currentUserId={idUsuario}
            currentUserName={nombreCompleto}
            isLoadingAgents={isLoadingAgents}
          />
        </Col>
      </Row>
    </div>
  );
};

export default DashboardView;
